if ( jQuery.fn.autocomplete.noConflict ) {
	var autocomplete = jQuery.fn.autocomplete.noConflict();
	jQuery.fn.algolia_autocomplete = autocomplete;
}



//////////////////
// WEBPACK FOOTER
// ./bower_components/algolia-autocomplete-no-conflict/no-conflict.js
// module id = 852
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91